import React, { useState } from 'react';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from 'reactstrap';

import filter from '../../assets/svg/filter.svg';
import close from '../../assets/svg/close.svg';

const GbDropdown = ({ menuItems, select, changeTab, placeholder, borderIcon, style }) => {
  
    const [ dropdownOpen, setDropdownOpen ] = useState(false);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    }

    const getStyle = () => {
      let stl = (dropdownOpen)?'gb-opendropdown':"btn btn-link nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light";
      stl += borderIcon?' gb-button-border':'';
      return stl;
    }

    return (
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggleDropdown}
        className="notification-list"
        style={style}
      >
        <DropdownToggle
          data-toggle="dropdown"
          tag="button"
          className={getStyle()}
          onClick={toggleDropdown}
          aria-expanded={dropdownOpen}
        >
          {borderIcon?(
          dropdownOpen?null:<img src={filter} height="17" style={{height:17, width:17, marginRight:6}}/>)
          :<i className="mdi mdi-chevron-down gb-color-primaria2"></i>}
          {placeholder}
          {(borderIcon && dropdownOpen)?<img src={close} height="20" style={{marginLeft:22}}/>:null}
        </DropdownToggle>
        <DropdownMenu right className="profile-dropdown">

            {menuItems && menuItems.map((item, i) => {
              return (
                  <DropdownItem key={i} onClick={() => changeTab(item)}>
                    <i className={(select==item)?"mdi mdi-checkbox-blank-circle gb-color-primaria2":"mdi mdi-checkbox-blank-circle-outline"}></i>{item}
                  </DropdownItem>
              );
            })}
          {/* </div> */}
        </DropdownMenu>
      </Dropdown>
    );

}

export default GbDropdown;
